export const List = () => import("./List.vue");
export const RemovedList = () => import("./RemovedList.vue");
export const Barcode = () => import("./Barcode.vue");
export const Create = () => import("./Create.vue");
export const Form = () => import("./Form.vue");
export const Edit = () => import("./Edit.vue");
